export default __webpack_public_path__ + "static/media/attractions6.4561e9ff.avif";